import { render } from "./BannerSubText.vue?vue&type=template&id=7b78869e"
import script from "./BannerSubText.vue?vue&type=script&lang=js"
export * from "./BannerSubText.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/livelitseats/litseats-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__